import React from "react";
import { Flex, Text, Box, Span, Alert, IconLocationPin } from "@catchoftheday/cg-components";
import DeliveryLocationInput from "./DeliveryLocationInput";
import { extractPostcodeAndSuburb } from "./utils";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var DeliveryLocationDesktop = function DeliveryLocationDesktop(_ref) {
  var setShowInput = _ref.setShowInput,
      showInput = _ref.showInput,
      selectedLocation = _ref.selectedLocation,
      handleItemSelected = _ref.handleItemSelected,
      handleAlertHide = _ref.handleAlertHide,
      serverError = _ref.serverError;
  return ___EmotionJSX(Flex, {
    flexDirection: {
      md: "column"
    },
    justifyContent: "center",
    alignItems: "flex-start",
    borderRight: {
      md: "1px solid white"
    },
    minWidth: {
      md: "110px",
      lg: "150px"
    },
    pl: {
      md: "0px"
    },
    pr: {
      md: "16px"
    },
    color: "white",
    "aria-label": "Delivery Location Selector"
  }, ___EmotionJSX(Text, {
    as: "div",
    m: "0px",
    lineHeight: "1"
  }, "Delivering to:"), ___EmotionJSX(Flex, {
    width: "100%",
    minHeight: "20px",
    position: "relative",
    flexDirection: "column",
    justifyContent: "center"
  }, ___EmotionJSX(Text, {
    as: "div",
    m: "0px",
    position: "absolute",
    borderBottom: "1px solid white",
    fontWeight: "bold",
    lineHeight: "1em",
    whiteSpace: "nowrap",
    overflow: "hidden",
    maxWidth: "100%",
    maxHeight: "20px",
    textOverflow: "ellipsis",
    textTransform: "capitalize",
    onClick: function onClick() {
      return setShowInput(true);
    }
  }, ___EmotionJSX(Span, null, ___EmotionJSX(IconLocationPin, {
    width: "10px",
    height: "12px",
    fill: "white",
    mr: {
      xs: "2px",
      xl: "4px"
    },
    "aria-hidden": "true"
  })), ___EmotionJSX(Box, {
    display: {
      md: "none",
      lg: "inline "
    }
  }, selectedLocation.title), ___EmotionJSX(Box, {
    display: {
      md: "inline",
      lg: "none "
    }
  }, extractPostcodeAndSuburb(selectedLocation.title).postcode)), showInput && ___EmotionJSX(Box, {
    position: "absolute",
    top: "0px",
    left: "0px",
    minWidth: "130px"
  }, ___EmotionJSX(DeliveryLocationInput, {
    selectedLocation: selectedLocation.title,
    onItemSelected: handleItemSelected,
    hideInput: function hideInput() {
      return setShowInput(false);
    },
    hideOnBlur: true
  })), serverError && !showInput && ___EmotionJSX(Box, {
    position: "absolute",
    top: "25px"
  }, ___EmotionJSX(Alert, {
    variant: "error",
    showPointer: true,
    timeoutDuration: 5000,
    hideAlert: handleAlertHide,
    wrapperProps: {
      minWidth: "225px"
    },
    pointerProps: {
      ml: "20px"
    }
  }, serverError))));
};